import { useState, useEffect } from 'react';
import Hero from './components/Hero';
import Products from './components/Products';
import Services from './components/Services';
import About from './components/About';
import Founder from './components/Founder';
import Promotions from './components/Promotions';
import Testimonials from './components/Testimonials';
import Contact from './components/Contact';
import Footer from './components/Footer';

export default function Home() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleWhatsAppClick = () => {
    window.open('https://wa.me/5511934728670?text=Olá!%20Vim%20pelo%20site%20e%20gostaria%20de%20tirar%20algumas%20dúvidas.%20Pode%20me%20orientar?', '_blank');
  };

  const handleNavClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    setMobileMenuOpen(false);
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <div className="min-h-screen bg-white">
      <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? 'bg-white shadow-md' : 'bg-transparent'
      }`}>
        <div className="max-w-[1400px] mx-auto px-6 md:px-8 py-3 md:py-4 flex items-center justify-between">
          {/* Mobile Menu Button - Left Side */}
          <button
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            className={`lg:hidden w-10 h-10 flex items-center justify-center ${
              scrolled ? 'text-gray-800' : 'text-white'
            }`}
          >
            <i className={`${mobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl`}></i>
          </button>

          {/* Desktop Menu */}
          <div className="hidden lg:flex items-center gap-8">
            <a href="#home" onClick={(e) => handleNavClick(e, '#home')} className={`text-sm font-medium transition-colors cursor-pointer whitespace-nowrap ${
              scrolled ? 'text-gray-800 hover:text-teal-600' : 'text-white hover:text-teal-300'
            }`}>Início</a>
            <a href="#produtos" onClick={(e) => handleNavClick(e, '#produtos')} className={`text-sm font-medium transition-colors cursor-pointer whitespace-nowrap ${
              scrolled ? 'text-gray-800 hover:text-teal-600' : 'text-white hover:text-teal-300'
            }`}>Produtos</a>
            <a href="#servicos" onClick={(e) => handleNavClick(e, '#servicos')} className={`text-sm font-medium transition-colors cursor-pointer whitespace-nowrap ${
              scrolled ? 'text-gray-800 hover:text-teal-600' : 'text-white hover:text-teal-300'
            }`}>Serviços</a>
            <a href="#sobre" onClick={(e) => handleNavClick(e, '#sobre')} className={`text-sm font-medium transition-colors cursor-pointer whitespace-nowrap ${
              scrolled ? 'text-gray-800 hover:text-teal-600' : 'text-white hover:text-teal-300'
            }`}>Sobre Nós</a>
            <a href="#promocoes" onClick={(e) => handleNavClick(e, '#promocoes')} className={`text-sm font-medium transition-colors cursor-pointer whitespace-nowrap ${
              scrolled ? 'text-gray-800 hover:text-teal-600' : 'text-white hover:text-teal-300'
            }`}>Promoções</a>
            <a href="#contato" onClick={(e) => handleNavClick(e, '#contato')} className={`text-sm font-medium transition-colors cursor-pointer whitespace-nowrap ${
              scrolled ? 'text-gray-800 hover:text-teal-600' : 'text-white hover:text-teal-300'
            }`}>Contato</a>
          </div>

          <button 
            onClick={handleWhatsAppClick}
            className="hidden md:flex bg-teal-500 hover:bg-teal-600 text-white px-4 md:px-6 py-2 md:py-2.5 rounded-full text-xs md:text-sm font-medium transition-all cursor-pointer whitespace-nowrap items-center gap-2"
          >
            <i className="ri-calendar-line"></i>
            Agende sua Consulta
          </button>

          {/* Logo - Right Side */}
          <div className="flex items-center gap-3">
            <img 
              src="https://static.readdy.ai/image/1b8131d487c4d2fd3e7c4221ca00b7be/a3a5d9ee133b24e450b546ebb2b7ceca.svg" 
              alt="Logo" 
              className="h-12 md:h-16 w-auto"
            />
          </div>
        </div>

        {/* Mobile Menu */}
        {mobileMenuOpen && (
          <div className="lg:hidden bg-white border-t border-gray-200">
            <div className="px-6 py-4 space-y-3">
              <a href="#home" onClick={(e) => handleNavClick(e, '#home')} className="block text-gray-800 hover:text-teal-600 font-medium cursor-pointer">Início</a>
              <a href="#produtos" onClick={(e) => handleNavClick(e, '#produtos')} className="block text-gray-800 hover:text-teal-600 font-medium cursor-pointer">Produtos</a>
              <a href="#servicos" onClick={(e) => handleNavClick(e, '#servicos')} className="block text-gray-800 hover:text-teal-600 font-medium cursor-pointer">Serviços</a>
              <a href="#sobre" onClick={(e) => handleNavClick(e, '#sobre')} className="block text-gray-800 hover:text-teal-600 font-medium cursor-pointer">Sobre Nós</a>
              <a href="#promocoes" onClick={(e) => handleNavClick(e, '#promocoes')} className="block text-gray-800 hover:text-teal-600 font-medium cursor-pointer">Promoções</a>
              <a href="#contato" onClick={(e) => handleNavClick(e, '#contato')} className="block text-gray-800 hover:text-teal-600 font-medium cursor-pointer">Contato</a>
              <button 
                onClick={handleWhatsAppClick}
                className="w-full bg-teal-500 hover:bg-teal-600 text-white px-4 py-3 rounded-full text-sm font-medium transition-all cursor-pointer whitespace-nowrap flex items-center justify-center gap-2"
              >
                <i className="ri-calendar-line"></i>
                Agende sua Consulta
              </button>
            </div>
          </div>
        )}
      </nav>

      <Hero />
      <Products />
      <Services />
      <About />
      <Founder />
      <Promotions />
      <Testimonials />
      <Contact />
      <Footer />

      {/* WhatsApp Floating Button */}
      <a
        href="https://wa.me/5511934728670?text=Olá!%20Vim%20pelo%20site%20e%20gostaria%20de%20tirar%20algumas%20dúvidas.%20Pode%20me%20orientar?"
        target="_blank"
        rel="noopener noreferrer"
        className="fixed bottom-6 right-6 z-50 w-14 h-14 bg-green-500 hover:bg-green-600 rounded-full flex items-center justify-center shadow-lg hover:shadow-xl transition-all duration-300 cursor-pointer hover:scale-110"
        aria-label="Fale conosco no WhatsApp"
      >
        <i className="ri-whatsapp-line text-white text-2xl"></i>
      </a>
    </div>
  );
}
